import React from "react";
import useObjectInput from "../../../../hooks/useObjectInput";

/**
 * Component that renders an item in the header, with conditional styling and functionality.
 * item - The current item to be rendered.
 * lastItemId - The ID of the last item in the list for comparison.
 */
const HeaderItem = ({ item, lastItemId }) => {
  // Destructuring highlightData and setActiveObjectId from the custom hook useObjectInput
  const { highlightData, setActiveObjectId } = useObjectInput();

  return (
    <div key={item?.id}>
      {/* Span element representing the header item with conditional styling based on highlightData */}
      <span
        style={
          // Apply fac711 background if item's id is in highlightData.dependenciesId
          highlightData.dependenciesId.some((id) => id === item?.id)
            ? { background: "#fac711" }
            // Apply red background if item's id is the same as highlightData.objectId
            : highlightData.objectId === item?.id
            ? { background: "red" }
            // Default to no additional styling
            : {}
        }
        onClick={setActiveObjectId}
        className="clickable"
        id={item?.id}
        key={item?.id}
      >
        {/* Display the item's name */}
        {item.name}
      </span>
      {/* Conditional rendering of a separator if the current item is not the last item */}
      {lastItemId !== item.id && <span className="gt px-5">{">"}</span>}
    </div>
  );
};

export default HeaderItem;